module.exports = __webpack_public_path__ + "static/media/orca.80e66372.png";